import { Link } from "react-router-dom";
import { User } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/i18n";
import { avatarSrc } from "@/lib/api";

export const AccountButton = ({ prefix = "" }) => {
  const { member } = useAuth();
  const { t } = useLang();
  const label = member ? t("nav.profile") : t("auth.login");
  return (
    <Link to={member ? "/perfil" : "/entrar"} className="icon-btn overflow-hidden" title={label} aria-label={label} data-testid={`${prefix}nav-account-btn`}>
      {member?.picture ? (
        <img src={avatarSrc(member.picture)} alt="" className="h-full w-full object-cover" referrerPolicy="no-referrer" />
      ) : member ? (
        <span className="font-display text-lg text-[var(--green)]">{(member.name || member.email)[0].toUpperCase()}</span>
      ) : (
        <User size={17} />
      )}
    </Link>
  );
};
